import React, { useEffect, useState } from 'react';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';

interface ConsultationCardProps {
  doctorName: string;
  date: string;
  time: string;
  photoUrl: string;
  startTime?: string;
  duration?: number;
  serverTime?: string;
}

const ConsultationCard: React.FC<ConsultationCardProps> = ({
  doctorName,
  date,
  time,
  photoUrl,
  duration,
  serverTime,
  startTime
}) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const getRemainingTime = () => {
    if (!startTime || !duration || !serverTime) return null;

    const startMs = new Date(startTime).getTime();
    const nowMs = now;
    const endMs = startMs + duration * 1000;

    const remaining = Math.max(Math.floor((endMs - nowMs) / 1000), 0);

    const m = Math.floor(remaining / 60);
    const s = remaining % 60;

    return `${m}m:${s}s`;
  };
  return (
    <div className="flex items-center border border-gray-500 rounded-xl p-3 mb-4">
      <img
        src={photoUrl}
        alt={doctorName}
        className="w-16 h-16 rounded-full object-cover mr-4"
      />
      <div className="flex flex-col">
        <p className="text-gray-600 font-semibold">Konsultasi dengan {doctorName}</p>
        <div className="flex items-center text-sm text-gray-600 mt-1">
          <FaCalendarAlt className="mr-2 text-gray-500" />
          {date}
        </div>
        <div className="flex items-center text-sm text-gray-600 mt-1">
          <FaClock className="mr-2 text-gray-500" />
          {time ? `${time} WIB` : ''}

          {getRemainingTime() && (
            <span className="ml-2 text-red-500 font-semibold">
              ({getRemainingTime()})
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsultationCard;
